//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
import "../no/JamTest.js";
let d=[[],[[[],"NewJamTest",{R_:{jamtest:"JamTest"}},0,0],[[],"GetAllocationStatistics",{R_:{stats:''}},0,0],[["count"],"GetOMSchemas",{R_:{schemas:"OMSchema[]"}},0,0],[["name"],"GetOMSchema",{R_:{schema:"OMSchema"}},1,0]],[["Colors","JamNXColorManager",0]]];
SPLM.JamSession = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.JamSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.JamSession.AllocationStatistics = class{
    constructor(num_jam_tests_allocated,num_jam_tests_deallocated){
        this.num_jam_tests_allocated=num_jam_tests_allocated;this.num_jam_tests_deallocated=num_jam_tests_deallocated;}
    get NumJamTestsAllocated(){return this.num_jam_tests_allocated}
    set NumJamTestsAllocated(val){this.num_jam_tests_allocated = val}
    get NumJamTestsDeallocated(){return this.num_jam_tests_deallocated}
    set NumJamTestsDeallocated(val){this.num_jam_tests_deallocated = val}
};

export default SPLM;